<template>
    <div v-if="pagination !== null && pagination.total > pagination.limit" class="row">
        <div class="col-12 mt-1 mb-1">
            <nav class="pr--pagination">
                <!--                <PaginationBase-->
                <!--                    :page-count="10"-->
                <!--                    :container-class="'pagination justify-content-end'"-->
                <!--                    :prev-text="'Предыдущая'"-->
                <!--                    :next-text="'Следующая'"-->
                <!--                    :click-handler="clickCallback"-->
                <!--                />-->
                <ul class="pagination">
                    <li :class="`page-item ${pagination.page === 1 ? 'disabled' : '' }`">
                        <a class="page-link" role="button" @click="changePage(pagination.page - 1)">
                            <IconFontAwesome :name="'chevron-left'" :title="'Предыдущая'" :empty-mobile-title="true" />
                        </a>
                    </li>
                    <li v-for="(page, key) in pages" :key="key" :class="`page-item ${pagination.page === page ? 'active' : ''}`">
                        <a
                            v-if="pagination.page !== page && page !== '...'"
                            class="page-link"
                            role="button"
                            @click="changePage(page)"
                        >
                            {{ page }}
                        </a>
                        <a
                            v-if="pagination.page !== page && page === '...'"
                            class="page-link"
                            role="button"
                        >
                            {{ page }}
                        </a>
                        <span
                            v-if="pagination.page === page"
                            class="page-link"
                        >
                            {{ page }}
                        </span>
                    </li>
                    <li :class="`page-item ${!pagination.has_more_pages ? 'disabled' : '' }`">
                        <a class="page-link" role="button" @click="changePage(pagination.page + 1)">
                            <IconFontAwesome :name="'chevron-right'" :title="'Следующая'" :empty-mobile-title="true" placement="right" />
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { defineComponent, toRefs, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import IconFontAwesome from '@/components/Icons/IconFontAwesome.vue';

export default defineComponent({
    name: 'PaginationRow',
    components: {
        IconFontAwesome
        //
    },
    props: {
        pagination: {
            type: [Object],
            default: () => null,
        },
        onChange: {
            type: [Function],
            default: null,
        },
    },
    setup(props) {
        const route = useRoute();
        const router = useRouter();
        const {
            pagination,
        } = toRefs(props);

        const page = pagination.value.page;
        //const limit = pagination.value.limit;
        //const total = pagination.value.total;

        function calculatePages(active, total, limit) {
            const totalPages = Math.ceil(total / limit);
            const paginationArray = [];
            const pagesToShow = 5;

            let startPage = Math.max(active - Math.floor(pagesToShow / 2), 1);
            let endPage = Math.min(startPage + pagesToShow - 1, totalPages);

            if (endPage - startPage + 1 < pagesToShow) {
                if (startPage === 1) {
                    endPage = Math.min(startPage + pagesToShow - 1, totalPages);
                } else {
                    startPage = Math.max(endPage - pagesToShow + 1, 1);
                }
            }

            if (startPage > 1) {
                paginationArray.push(1);
                if (startPage > 2) {
                    paginationArray.push('...');
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                paginationArray.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    paginationArray.push('...');
                }
                paginationArray.push(totalPages);
            }
            return paginationArray;
        }

        //
        const pages = computed(() => calculatePages(pagination.value.page, pagination.value.total, pagination.value.limit));

        watch(() => pagination.value.page, () => {
            pages.value = calculatePages(pagination.value.page, pagination.value.total, pagination.value.limit);
            console.log(pages);
        });

        //console.log(page, pages);
        return {
            pages,
            route,
            router,
        };
    },

    computed: {
        // paginate() {
        //     if (!this.users || this.users.length != this.users.length) {
        //         return
        //     }
        //     this.resultCount = this.users.length
        //     if (this.currentPage >= this.totalPages) {
        //         this.currentPage = this.totalPages
        //     }
        //     var index = this.currentPage * this.itemsPerPage - this.itemsPerPage
        //     return this.users.slice(index, index + this.itemsPerPage)
        // }
    },
    methods: {
        changePage(page) {
            this.onChange(page);
        }
    }
});
</script>
